
import React from 'react';
import { Checkbox } from '../ui/checkbox';

interface DocumentTableHeaderProps {
  handleSelectAll: (checked: boolean) => void;
  selectedDocumentsCount: number;
  filteredDocumentsLength: number;
}

const DocumentTableHeader: React.FC<DocumentTableHeaderProps> = ({
  handleSelectAll,
  selectedDocumentsCount,
  filteredDocumentsLength,
}) => {
  return (
    <div className="p-3 bg-gray-50 border-b flex text-sm font-medium text-gray-600">
      <div className="w-10">
        <Checkbox 
          checked={selectedDocumentsCount > 0 && selectedDocumentsCount === filteredDocumentsLength} 
          onCheckedChange={handleSelectAll}
        />
      </div>
      <div className="flex-1">Document</div>
      <div className="w-40 text-center">Tags</div>
      <div className="w-48 text-center">Last Updated</div>
      <div className="w-36 text-center">Actions</div>
    </div>
  );
};

export default DocumentTableHeader;
